<template>
  <div class="container-custom">
    <!-- breadscrumbs -->
    <div class="breadscrumbs">
      <a class="breadscrumbs-item active">ESG Page</a>
    </div>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>ESG Page</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="toNavigationEdit">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>

    <!-- block 1 -->
    <div class="block mb-5" v-if="csr">
      <!-- Page Title -->
      <div class="form-item d-flex pa-5">
        <h4 class="w-240px mr-5">Page Title</h4>
        <div class="h4">{{ csr.title }}</div>
      </div>
      <!-- Background -->
      <div class="form-item d-flex pa-5">
        <h4 class="w-240px mr-5">Background</h4>
        <div
          class="w-280px h-187px bg-cover bg-center"
          :style="{
            'background-image': `url(${csr.background})`,
            'border-radius': '8px',
            'background-size': 'contain',
          }"
        ></div>
      </div>
      <!-- Call to Action
      <div class="form-item d-flex pa-5">
        <h4 class="w-240px mr-5">Call to Action</h4>
        <div class="h4">{{ csr.call_to_action }}</div>
      </div> -->
      <!-- CTA Type
      <div class="form-item d-flex pa-5">
        <h4 class="w-240px mr-5">CTA Type</h4>
        <div class="h4">
          <a href="#" style="text-decoration: none;">{{ csr.url }}</a>
        </div>
      </div> -->
      <!-- Description -->
      <div class="form-item d-flex pt-5">
        <h4 class="w-240px mr-5">Description</h4>
        <div class="h4">{{ csr.description }}</div>
      </div>
    </div>

    <!-- block 2 -->
    <div class="block" style="margin-bottom: 30px;" v-if="csr">
      <PageMenu :sections="sections">
        <component :is="sectionView" :csr="csr"></component>
      </PageMenu>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import PageMenu from '@/components/PageMenu.vue';
import ProjectFilter from '@/views/B-4__CSRPage/c/B-4-1__CSRPage_ProjectFilter.vue';
import ProjectShowcasePage from '@/views/B-4__CSRPage/c/B-4-2__CSRPage_ProjectShowcasePage.vue';
import VideoRotate from '@/views/B-4__CSRPage/c/B-4-3__CSRPage_VideoRotate.vue';
import MainVisual from '@/views/B-4__CSRPage/c/C-4-4__CSRPageEdit_MainVisual.vue';

export default {
  components: {
    PageMenu,
    ProjectFilter,
    ProjectShowcasePage,
    VideoRotate,
    MainVisual,
  },
  data: () => ({
    sections: [
      { name: 'ESG Project Tab', component: 'ProjectFilter' },
      { name: 'Project Showcase', component: 'ProjectShowcasePage' },
      //{ name: 'Video Rotate', component: 'VideoRotate' },
      { name: 'Main Visual', component: 'MainVisual' },
    ],
  }),
  computed: {
    ...mapState('csr', ['csr']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  async created() {
    await this.getCsr();
  },
  methods: {
    ...mapActions('csr', {
      getCsr: 'find',
    }),
    toNavigationEdit() {
      this.$router.push({
        name: 'CSRPageEdit',
        query: {
          section: this.$route.query.section,
        },
      });
    },
  },
};
</script>

<style></style>
